import {API_ROOT} from '../config/ApiConfig';
import {generateRequestHeaders} from '../service/ApiService';

export interface PropensityPreferenceResponse {
  customerId?: string;
  churnLevel?: string;
  seatAdditionLevel?: string;
  httpstatus: number;
  reason?: string;
  message?: string;
  code?: string;
}

export async function getPropensityPreference(
  customerId: string
): Promise<PropensityPreferenceResponse> {
  const endpoint = `${API_ROOT}/data/propensity/preferences?customer_id=${encodeURIComponent(customerId)}`;
  const response = await fetch(endpoint, {
    headers: generateRequestHeaders()
  });
  const data = await response.json();
  data.httpstatus = response.status;
  return data;
}

export async function setPropensityPreference(
  customerId: string,
  churnLevel?: string,
  seatAdditionLevel?: string
): Promise<PropensityPreferenceResponse> {
  const endpoint = `${API_ROOT}/data/propensity/preferences`;
  const body: {customerId: string; churnLevel?: string; seatAdditionLevel?: string} = {
    customerId: customerId
  };
  // Omit unchanged fields entirely — the PUT API keeps a field's existing value when it's
  // not present in the body, so only the level(s) the user actually changed are sent.
  if (churnLevel !== undefined) {
    body.churnLevel = churnLevel;
  }
  if (seatAdditionLevel !== undefined) {
    body.seatAdditionLevel = seatAdditionLevel;
  }
  const response = await fetch(endpoint, {
    headers: generateRequestHeaders(),
    method: 'PUT',
    body: JSON.stringify(body)
  });
  const data = await response.json();
  data.httpstatus = response.status;
  return data;
}

export async function deletePropensityPreference(
  customerId: string
): Promise<PropensityPreferenceResponse> {
  const endpoint = `${API_ROOT}/data/propensity/preferences?customer_id=${encodeURIComponent(customerId)}`;
  const response = await fetch(endpoint, {
    headers: generateRequestHeaders(),
    method: 'DELETE'
  });
  const data = response.status === 204 ? {} : await response.json();
  data.httpstatus = response.status;
  return data;
}
